import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
;import { LoyaltyProgram } from '../models/entities/loyalty-program';
import { LoyaltyProgramRequest } from '../models/dtos/loyalty-program-request';
import { LoyaltyProgramRelease } from '../models/entities/loyalty-program-release';
import { LoyaltyProgramReleaseRequest } from '../models/dtos/loyalty-program-release-request';
import { Kpi } from 'src/app/assabil-kernel/models/entities/control-tables/kpi-entity';


@Injectable({
  providedIn: 'root'
})


export class LoyaltyService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { 
  }
  

  
  kpisGet(code : string, name : string): Promise<Kpi[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1  = code;
    request.strArg2  = name;
   
    return new Promise((resolve) => {
        this.networkService.post('loyalty/kpisGet', request).then(result => {
            return resolve(result.kpis);   
        });
    });
  }

  loyaltyProgramsGet(code : string, name : string): Promise<LoyaltyProgram[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1  = code;
    request.strArg2  = name;
   
    return new Promise((resolve) => {
        this.networkService.post('loyalty/loyaltyProgramsGet', request).then(result => {
            return resolve(result.loyaltyPrograms);   
        });
    });
  }

  loyaltyProgramSave(loyaltyProgram: LoyaltyProgram): Promise<LoyaltyProgram> {
    let request: LoyaltyProgramRequest = new LoyaltyProgramRequest(this.userService.userInfo);
    request.loyaltyProgram      = loyaltyProgram;
   
    return new Promise((resolve) => {
        this.networkService.post('loyalty/loyaltyProgramSave', request).then(result => {
            return resolve(result.loyaltyProgram);   
        });
    });
  }


  loyaltyProgramReleasesGet(loyaltyProgramCode: string, loyaltyProgramReleaseCode: string, startDate: Date, endDate: Date, active: boolean, inactive: boolean): Promise<LoyaltyProgramRelease[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1  = loyaltyProgramCode;
    request.strArg2  = loyaltyProgramReleaseCode;
    request.dteArg1  = startDate;
    request.dteArg2  = endDate;
    request.blnArg1  = active;
    request.blnArg2  = inactive;
   
    return new Promise((resolve) => {
        this.networkService.post('loyalty/loyaltyProgramReleasesGet', request).then(result => {
            return resolve(result.loyaltyProgramReleases);   
        });
    });
  }
 
  
  loyaltyProgramReleaseGet(loyaltyProgramReleaseCode: string): Promise<LoyaltyProgramRelease> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code  = loyaltyProgramReleaseCode;
   
    return new Promise((resolve) => {
        this.networkService.post('loyalty/loyaltyProgramReleaseGet', request).then(result => {
            return resolve(result.loyaltyProgramRelease);   
        });
    });
  }
 

  loyaltyProgramReleaseSave(loyaltyProgramRelease: LoyaltyProgramRelease): Promise<LoyaltyProgramRelease> {
    let request: LoyaltyProgramReleaseRequest = new LoyaltyProgramReleaseRequest(this.userService.userInfo);
    request.loyaltyProgramRelease      = loyaltyProgramRelease;
   
    return new Promise((resolve) => {
        this.networkService.post('loyalty/loyaltyProgramReleaseSave', request).then(result => {
            return resolve(result.loyaltyProgramRelease);   
        });
    });
  }


}

